// source: io/codedrills/proto/user/team_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_view_pb);
var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_preview_pb);
var io_codedrills_proto_user_team_pb = require('../../../../io/codedrills/proto/user/team_pb.js');
goog.object.extend(proto, io_codedrills_proto_user_team_pb);
var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_pb);
var io_codedrills_proto_content_pagination_pb = require('../../../../io/codedrills/proto/content/pagination_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_pagination_pb);
goog.exportSymbol('proto.io.codedrills.proto.user.CreateTeamRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CreateTeamResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CreateTeamsBatchRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.CreateTeamsBatchResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.DeleteTeamAdminRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.DeleteTeamAdminResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.DeleteTeamRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.DeleteTeamResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamAdminRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamAdminRequest.TeamIdentityCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamAdminResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetTeamsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetUserContentTeamsRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetUserContentTeamsResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetUserTeamMappingRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.GetUserTeamMappingResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ImportTeamsToContestRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.ImportTeamsToContestResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.UpdateTeamInviteRequest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.user.UpdateTeamInviteResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CreateTeamsBatchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CreateTeamsBatchRequest.displayName = 'proto.io.codedrills.proto.user.CreateTeamsBatchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CreateTeamsBatchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CreateTeamsBatchResponse.displayName = 'proto.io.codedrills.proto.user.CreateTeamsBatchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetTeamRequest.displayName = 'proto.io.codedrills.proto.user.GetTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CreateTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CreateTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CreateTeamRequest.displayName = 'proto.io.codedrills.proto.user.CreateTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.CreateTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.CreateTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.CreateTeamResponse.displayName = 'proto.io.codedrills.proto.user.CreateTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetTeamResponse.displayName = 'proto.io.codedrills.proto.user.GetTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.UpdateTeamInviteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.UpdateTeamInviteRequest.displayName = 'proto.io.codedrills.proto.user.UpdateTeamInviteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.UpdateTeamInviteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.UpdateTeamInviteResponse.displayName = 'proto.io.codedrills.proto.user.UpdateTeamInviteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.DeleteTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.DeleteTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.DeleteTeamRequest.displayName = 'proto.io.codedrills.proto.user.DeleteTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.DeleteTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.DeleteTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.DeleteTeamResponse.displayName = 'proto.io.codedrills.proto.user.DeleteTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetTeamsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetTeamsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetTeamsRequest.displayName = 'proto.io.codedrills.proto.user.GetTeamsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetTeamsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.GetTeamsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetTeamsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetTeamsResponse.displayName = 'proto.io.codedrills.proto.user.GetTeamsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetUserContentTeamsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetUserContentTeamsRequest.displayName = 'proto.io.codedrills.proto.user.GetUserContentTeamsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.GetUserContentTeamsResponse.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetUserContentTeamsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetUserContentTeamsResponse.displayName = 'proto.io.codedrills.proto.user.GetUserContentTeamsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.displayName = 'proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.displayName = 'proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.displayName = 'proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.displayName = 'proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetUserTeamMappingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetUserTeamMappingRequest.displayName = 'proto.io.codedrills.proto.user.GetUserTeamMappingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetUserTeamMappingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetUserTeamMappingResponse.displayName = 'proto.io.codedrills.proto.user.GetUserTeamMappingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.user.GetTeamAdminRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetTeamAdminRequest.displayName = 'proto.io.codedrills.proto.user.GetTeamAdminRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.GetTeamAdminResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.GetTeamAdminResponse.displayName = 'proto.io.codedrills.proto.user.GetTeamAdminResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.DeleteTeamAdminRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.DeleteTeamAdminRequest.displayName = 'proto.io.codedrills.proto.user.DeleteTeamAdminRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.DeleteTeamAdminResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.DeleteTeamAdminResponse.displayName = 'proto.io.codedrills.proto.user.DeleteTeamAdminResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.user.ImportTeamsToContestRequest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.user.ImportTeamsToContestRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ImportTeamsToContestRequest.displayName = 'proto.io.codedrills.proto.user.ImportTeamsToContestRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.user.ImportTeamsToContestResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.user.ImportTeamsToContestResponse.displayName = 'proto.io.codedrills.proto.user.ImportTeamsToContestResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CreateTeamsBatchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamsCsv: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CreateTeamsBatchRequest;
  return proto.io.codedrills.proto.user.CreateTeamsBatchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamsCsv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CreateTeamsBatchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamsCsv();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string teams_csv = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.prototype.getTeamsCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} returns this
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.prototype.setTeamsCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 content_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.CreateTeamsBatchRequest} returns this
 */
proto.io.codedrills.proto.user.CreateTeamsBatchRequest.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CreateTeamsBatchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CreateTeamsBatchResponse}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CreateTeamsBatchResponse;
  return proto.io.codedrills.proto.user.CreateTeamsBatchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CreateTeamsBatchResponse}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CreateTeamsBatchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CreateTeamsBatchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamsBatchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetTeamRequest}
 */
proto.io.codedrills.proto.user.GetTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetTeamRequest;
  return proto.io.codedrills.proto.user.GetTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetTeamRequest}
 */
proto.io.codedrills.proto.user.GetTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 team_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.GetTeamRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.GetTeamRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CreateTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CreateTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CreateTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamDetails: (f = msg.getTeamDetails()) && io_codedrills_proto_user_team_pb.TeamDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CreateTeamRequest}
 */
proto.io.codedrills.proto.user.CreateTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CreateTeamRequest;
  return proto.io.codedrills.proto.user.CreateTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CreateTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CreateTeamRequest}
 */
proto.io.codedrills.proto.user.CreateTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_user_team_pb.TeamDetails;
      reader.readMessage(value,io_codedrills_proto_user_team_pb.TeamDetails.deserializeBinaryFromReader);
      msg.setTeamDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CreateTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CreateTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CreateTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_user_team_pb.TeamDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional TeamDetails team_details = 1;
 * @return {?proto.io.codedrills.proto.user.TeamDetails}
 */
proto.io.codedrills.proto.user.CreateTeamRequest.prototype.getTeamDetails = function() {
  return /** @type{?proto.io.codedrills.proto.user.TeamDetails} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_team_pb.TeamDetails, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.TeamDetails|undefined} value
 * @return {!proto.io.codedrills.proto.user.CreateTeamRequest} returns this
*/
proto.io.codedrills.proto.user.CreateTeamRequest.prototype.setTeamDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CreateTeamRequest} returns this
 */
proto.io.codedrills.proto.user.CreateTeamRequest.prototype.clearTeamDetails = function() {
  return this.setTeamDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CreateTeamRequest.prototype.hasTeamDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.CreateTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.CreateTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.CreateTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamView: (f = msg.getTeamView()) && io_codedrills_proto_content_view_pb.TeamView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.CreateTeamResponse}
 */
proto.io.codedrills.proto.user.CreateTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.CreateTeamResponse;
  return proto.io.codedrills.proto.user.CreateTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.CreateTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.CreateTeamResponse}
 */
proto.io.codedrills.proto.user.CreateTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.TeamView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.TeamView.deserializeBinaryFromReader);
      msg.setTeamView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.CreateTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.CreateTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.CreateTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.CreateTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.TeamView.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.TeamView team_view = 1;
 * @return {?proto.io.codedrills.proto.content.TeamView}
 */
proto.io.codedrills.proto.user.CreateTeamResponse.prototype.getTeamView = function() {
  return /** @type{?proto.io.codedrills.proto.content.TeamView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.TeamView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.TeamView|undefined} value
 * @return {!proto.io.codedrills.proto.user.CreateTeamResponse} returns this
*/
proto.io.codedrills.proto.user.CreateTeamResponse.prototype.setTeamView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.CreateTeamResponse} returns this
 */
proto.io.codedrills.proto.user.CreateTeamResponse.prototype.clearTeamView = function() {
  return this.setTeamView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.CreateTeamResponse.prototype.hasTeamView = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamView: (f = msg.getTeamView()) && io_codedrills_proto_content_view_pb.TeamView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetTeamResponse}
 */
proto.io.codedrills.proto.user.GetTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetTeamResponse;
  return proto.io.codedrills.proto.user.GetTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetTeamResponse}
 */
proto.io.codedrills.proto.user.GetTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.TeamView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.TeamView.deserializeBinaryFromReader);
      msg.setTeamView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.TeamView.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.TeamView team_view = 1;
 * @return {?proto.io.codedrills.proto.content.TeamView}
 */
proto.io.codedrills.proto.user.GetTeamResponse.prototype.getTeamView = function() {
  return /** @type{?proto.io.codedrills.proto.content.TeamView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.TeamView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.TeamView|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetTeamResponse} returns this
*/
proto.io.codedrills.proto.user.GetTeamResponse.prototype.setTeamView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamResponse} returns this
 */
proto.io.codedrills.proto.user.GetTeamResponse.prototype.clearTeamView = function() {
  return this.setTeamView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamResponse.prototype.hasTeamView = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.UpdateTeamInviteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    membershipState: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.UpdateTeamInviteRequest;
  return proto.io.codedrills.proto.user.UpdateTeamInviteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.user.MembershipState} */ (reader.readEnum());
      msg.setMembershipState(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.UpdateTeamInviteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMembershipState();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int32 team_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} returns this
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MembershipState membership_state = 2;
 * @return {!proto.io.codedrills.proto.user.MembershipState}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.prototype.getMembershipState = function() {
  return /** @type {!proto.io.codedrills.proto.user.MembershipState} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.user.MembershipState} value
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteRequest} returns this
 */
proto.io.codedrills.proto.user.UpdateTeamInviteRequest.prototype.setMembershipState = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.UpdateTeamInviteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamView: (f = msg.getTeamView()) && io_codedrills_proto_content_view_pb.TeamView.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.UpdateTeamInviteResponse;
  return proto.io.codedrills.proto.user.UpdateTeamInviteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.TeamView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.TeamView.deserializeBinaryFromReader);
      msg.setTeamView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.UpdateTeamInviteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamView();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.TeamView.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.TeamView team_view = 1;
 * @return {?proto.io.codedrills.proto.content.TeamView}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.prototype.getTeamView = function() {
  return /** @type{?proto.io.codedrills.proto.content.TeamView} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_view_pb.TeamView, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.TeamView|undefined} value
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse} returns this
*/
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.prototype.setTeamView = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.UpdateTeamInviteResponse} returns this
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.prototype.clearTeamView = function() {
  return this.setTeamView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.UpdateTeamInviteResponse.prototype.hasTeamView = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.DeleteTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.DeleteTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamRequest}
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.DeleteTeamRequest;
  return proto.io.codedrills.proto.user.DeleteTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamRequest}
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.DeleteTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 team_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.DeleteTeamRequest} returns this
 */
proto.io.codedrills.proto.user.DeleteTeamRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.DeleteTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.DeleteTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.DeleteTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamResponse}
 */
proto.io.codedrills.proto.user.DeleteTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.DeleteTeamResponse;
  return proto.io.codedrills.proto.user.DeleteTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamResponse}
 */
proto.io.codedrills.proto.user.DeleteTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.DeleteTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.DeleteTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetTeamsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetTeamsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: (f = msg.getContestId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f),
    paginationQuery: (f = msg.getPaginationQuery()) && io_codedrills_proto_content_pagination_pb.PaginationQuery.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetTeamsRequest}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetTeamsRequest;
  return proto.io.codedrills.proto.user.GetTeamsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetTeamsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetTeamsRequest}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContestId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationQuery;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationQuery.deserializeBinaryFromReader);
      msg.setPaginationQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetTeamsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetTeamsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
  f = message.getPaginationQuery();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationQuery.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId contest_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.getContestId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetTeamsRequest} returns this
*/
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.setContestId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamsRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.clearContestId = function() {
  return this.setContestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.hasContestId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional io.codedrills.proto.content.PaginationQuery pagination_query = 2;
 * @return {?proto.io.codedrills.proto.content.PaginationQuery}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.getPaginationQuery = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationQuery} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationQuery, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationQuery|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetTeamsRequest} returns this
*/
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.setPaginationQuery = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamsRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.clearPaginationQuery = function() {
  return this.setPaginationQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamsRequest.prototype.hasPaginationQuery = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.GetTeamsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetTeamsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetTeamsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamPreviewList: jspb.Message.toObjectList(msg.getTeamPreviewList(),
    io_codedrills_proto_content_preview_pb.TeamPreview.toObject, includeInstance),
    paginationResponse: (f = msg.getPaginationResponse()) && io_codedrills_proto_content_pagination_pb.PaginationResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetTeamsResponse}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetTeamsResponse;
  return proto.io.codedrills.proto.user.GetTeamsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetTeamsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetTeamsResponse}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_preview_pb.TeamPreview;
      reader.readMessage(value,io_codedrills_proto_content_preview_pb.TeamPreview.deserializeBinaryFromReader);
      msg.addTeamPreview(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_pagination_pb.PaginationResponse;
      reader.readMessage(value,io_codedrills_proto_content_pagination_pb.PaginationResponse.deserializeBinaryFromReader);
      msg.setPaginationResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetTeamsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetTeamsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamPreviewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_preview_pb.TeamPreview.serializeBinaryToWriter
    );
  }
  f = message.getPaginationResponse();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_pagination_pb.PaginationResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.TeamPreview team_preview = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.TeamPreview>}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.getTeamPreviewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.TeamPreview>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_preview_pb.TeamPreview, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.TeamPreview>} value
 * @return {!proto.io.codedrills.proto.user.GetTeamsResponse} returns this
*/
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.setTeamPreviewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.TeamPreview=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.TeamPreview}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.addTeamPreview = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.TeamPreview, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.GetTeamsResponse} returns this
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.clearTeamPreviewList = function() {
  return this.setTeamPreviewList([]);
};


/**
 * optional io.codedrills.proto.content.PaginationResponse pagination_response = 2;
 * @return {?proto.io.codedrills.proto.content.PaginationResponse}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.getPaginationResponse = function() {
  return /** @type{?proto.io.codedrills.proto.content.PaginationResponse} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_pagination_pb.PaginationResponse, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.PaginationResponse|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetTeamsResponse} returns this
*/
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.setPaginationResponse = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamsResponse} returns this
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.clearPaginationResponse = function() {
  return this.setPaginationResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamsResponse.prototype.hasPaginationResponse = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetUserContentTeamsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: (f = msg.getContestId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetUserContentTeamsRequest;
  return proto.io.codedrills.proto.user.GetUserContentTeamsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetUserContentTeamsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.content.ContentId contest_id = 1;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.prototype.getContestId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} returns this
*/
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.prototype.setContestId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsRequest} returns this
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.prototype.clearContestId = function() {
  return this.setContestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsRequest.prototype.hasContestId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetUserContentTeamsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamViewList: jspb.Message.toObjectList(msg.getTeamViewList(),
    io_codedrills_proto_content_view_pb.TeamView.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetUserContentTeamsResponse;
  return proto.io.codedrills.proto.user.GetUserContentTeamsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_content_view_pb.TeamView;
      reader.readMessage(value,io_codedrills_proto_content_view_pb.TeamView.deserializeBinaryFromReader);
      msg.addTeamView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetUserContentTeamsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamViewList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      io_codedrills_proto_content_view_pb.TeamView.serializeBinaryToWriter
    );
  }
};


/**
 * repeated io.codedrills.proto.content.TeamView team_view = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.TeamView>}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.prototype.getTeamViewList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.TeamView>} */ (
    jspb.Message.getRepeatedWrapperField(this, io_codedrills_proto_content_view_pb.TeamView, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.TeamView>} value
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse} returns this
*/
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.prototype.setTeamViewList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.TeamView=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.TeamView}
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.prototype.addTeamView = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.TeamView, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.GetUserContentTeamsResponse} returns this
 */
proto.io.codedrills.proto.user.GetUserContentTeamsResponse.prototype.clearTeamViewList = function() {
  return this.setTeamViewList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest;
  return proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} returns this
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 2;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} returns this
*/
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest} returns this
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isAcceptedMember: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse;
  return proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAcceptedMember(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsAcceptedMember();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_accepted_member = 1;
 * @return {boolean}
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.prototype.getIsAcceptedMember = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse} returns this
 */
proto.io.codedrills.proto.user.IsAcceptedMemberInContestResponse.prototype.setIsAcceptedMember = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contentId: (f = msg.getContentId()) && io_codedrills_proto_content_content_pb.ContentId.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest;
  return proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = new io_codedrills_proto_content_content_pb.ContentId;
      reader.readMessage(value,io_codedrills_proto_content_content_pb.ContentId.deserializeBinaryFromReader);
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContentId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      io_codedrills_proto_content_content_pb.ContentId.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} returns this
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional io.codedrills.proto.content.ContentId content_id = 2;
 * @return {?proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.getContentId = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentId} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_content_content_pb.ContentId, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentId|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} returns this
*/
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.setContentId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest} returns this
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.clearContentId = function() {
  return this.setContentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamRequest.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamDetails: (f = msg.getTeamDetails()) && io_codedrills_proto_user_team_pb.TeamDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse;
  return proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_user_team_pb.TeamDetails;
      reader.readMessage(value,io_codedrills_proto_user_team_pb.TeamDetails.deserializeBinaryFromReader);
      msg.setTeamDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_user_team_pb.TeamDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional TeamDetails team_details = 1;
 * @return {?proto.io.codedrills.proto.user.TeamDetails}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.prototype.getTeamDetails = function() {
  return /** @type{?proto.io.codedrills.proto.user.TeamDetails} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_team_pb.TeamDetails, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.TeamDetails|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse} returns this
*/
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.prototype.setTeamDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse} returns this
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.prototype.clearTeamDetails = function() {
  return this.setTeamDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetAcceptedUserContentTeamResponse.prototype.hasTeamDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetUserTeamMappingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contestId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetUserTeamMappingRequest;
  return proto.io.codedrills.proto.user.GetUserTeamMappingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetUserTeamMappingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContestId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 contest_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.prototype.getContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.GetUserTeamMappingRequest} returns this
 */
proto.io.codedrills.proto.user.GetUserTeamMappingRequest.prototype.setContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetUserTeamMappingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    userTeamMap: (f = msg.getUserTeamMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetUserTeamMappingResponse}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetUserTeamMappingResponse;
  return proto.io.codedrills.proto.user.GetUserTeamMappingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetUserTeamMappingResponse}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getUserTeamMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetUserTeamMappingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetUserTeamMappingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserTeamMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * map<string, int32> user_team = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.prototype.getUserTeamMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.user.GetUserTeamMappingResponse} returns this
 */
proto.io.codedrills.proto.user.GetUserTeamMappingResponse.prototype.clearUserTeamMap = function() {
  this.getUserTeamMap().clear();
  return this;};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_ = [[2,3,4]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.TeamIdentityCase = {
  TEAM_IDENTITY_NOT_SET: 0,
  TEAM_ID: 2,
  MEMBER_EMAIL: 3,
  EXTERNAL_ID: 4
};

/**
 * @return {proto.io.codedrills.proto.user.GetTeamAdminRequest.TeamIdentityCase}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.getTeamIdentityCase = function() {
  return /** @type {proto.io.codedrills.proto.user.GetTeamAdminRequest.TeamIdentityCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetTeamAdminRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    teamId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    memberEmail: jspb.Message.getFieldWithDefault(msg, 3, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetTeamAdminRequest;
  return proto.io.codedrills.proto.user.GetTeamAdminRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetTeamAdminRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 team_id = 2;
 * @return {number}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.clearTeamId = function() {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.hasTeamId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string member_email = 3;
 * @return {string}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.getMemberEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.setMemberEmail = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.clearMemberEmail = function() {
  return jspb.Message.setOneofField(this, 3, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.hasMemberEmail = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string external_id = 4;
 * @return {string}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.setExternalId = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.clearExternalId = function() {
  return jspb.Message.setOneofField(this, 4, proto.io.codedrills.proto.user.GetTeamAdminRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamAdminRequest.prototype.hasExternalId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.GetTeamAdminResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamDetails: (f = msg.getTeamDetails()) && io_codedrills_proto_user_team_pb.TeamDetails.toObject(includeInstance, f),
    externalId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminResponse}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.GetTeamAdminResponse;
  return proto.io.codedrills.proto.user.GetTeamAdminResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminResponse}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_user_team_pb.TeamDetails;
      reader.readMessage(value,io_codedrills_proto_user_team_pb.TeamDetails.deserializeBinaryFromReader);
      msg.setTeamDetails(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.GetTeamAdminResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.GetTeamAdminResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamDetails();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_user_team_pb.TeamDetails.serializeBinaryToWriter
    );
  }
  f = message.getExternalId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional TeamDetails team_details = 1;
 * @return {?proto.io.codedrills.proto.user.TeamDetails}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.getTeamDetails = function() {
  return /** @type{?proto.io.codedrills.proto.user.TeamDetails} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_user_team_pb.TeamDetails, 1));
};


/**
 * @param {?proto.io.codedrills.proto.user.TeamDetails|undefined} value
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminResponse} returns this
*/
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.setTeamDetails = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminResponse} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.clearTeamDetails = function() {
  return this.setTeamDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.hasTeamDetails = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string external_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.GetTeamAdminResponse} returns this
 */
proto.io.codedrills.proto.user.GetTeamAdminResponse.prototype.setExternalId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.DeleteTeamAdminRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.DeleteTeamAdminRequest;
  return proto.io.codedrills.proto.user.DeleteTeamAdminRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.DeleteTeamAdminRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 team_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.DeleteTeamAdminRequest} returns this
 */
proto.io.codedrills.proto.user.DeleteTeamAdminRequest.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.DeleteTeamAdminResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamAdminResponse}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.DeleteTeamAdminResponse;
  return proto.io.codedrills.proto.user.DeleteTeamAdminResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.DeleteTeamAdminResponse}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.DeleteTeamAdminResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.DeleteTeamAdminResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.DeleteTeamAdminResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ImportTeamsToContestRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    teamsCsv: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fromContestId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    toContestId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ImportTeamsToContestRequest;
  return proto.io.codedrills.proto.user.ImportTeamsToContestRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setTeamIdList(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTeamsCsv(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFromContestId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setToContestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ImportTeamsToContestRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamIdList();
  if (f.length > 0) {
    writer.writePackedInt32(
      1,
      f
    );
  }
  f = message.getTeamsCsv();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFromContestId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getToContestId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated int32 team_id = 1;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.getTeamIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} returns this
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.setTeamIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} returns this
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.addTeamId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} returns this
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.clearTeamIdList = function() {
  return this.setTeamIdList([]);
};


/**
 * optional string teams_csv = 2;
 * @return {string}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.getTeamsCsv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} returns this
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.setTeamsCsv = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 from_contest_id = 3;
 * @return {number}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.getFromContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} returns this
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.setFromContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 to_contest_id = 4;
 * @return {number}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.getToContestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestRequest} returns this
 */
proto.io.codedrills.proto.user.ImportTeamsToContestRequest.prototype.setToContestId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.user.ImportTeamsToContestResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestResponse}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.user.ImportTeamsToContestResponse;
  return proto.io.codedrills.proto.user.ImportTeamsToContestResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.user.ImportTeamsToContestResponse}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.user.ImportTeamsToContestResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.user.ImportTeamsToContestResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.user.ImportTeamsToContestResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.io.codedrills.proto.user);
